import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { updateFarm } from 'reducers/admin/farms';
// components
import WaterMetersPanel from './components/WaterMetersPanel/WaterMetersPanel';

const FarmWaterMeters = ({ farm, updateFarm }) => (
  <WaterMetersPanel farm={farm} updateFarm={updateFarm} />
);

FarmWaterMeters.propTypes = {
  farm: T.object.isRequired,
  updateFarm: T.func.isRequired,
};

export default connect(
  (state) => ({ farm: state.farms.resource.data }),
  { updateFarm }
)(FarmWaterMeters);
